import { IWorkingDays } from '@interfaces/cmModule/operationWindowRules';
import { TRange } from '@interfaces/common/range';
import { IGroupSelectItem } from '@components/common/GroupSelect/GroupSelect.types';

export const checkIsAllSelectedHasRanges = (scheduleFields: IWorkingDays[]) => {
	const enabled = scheduleFields.filter((day) => day.isEnabled);

	return enabled.length > 0 ? enabled.every((day) => day.ranges && day.ranges.length > 0) : false;
};

export const checkIsEnabledDaysScheduleChanged = (
	selectedSchedule: IWorkingDays[],
	defaultSchedule: IWorkingDays[],
): boolean => {
	const isRuleModified = selectedSchedule.some((day, index) => {
		const defaultDay = defaultSchedule[index];

		if (!defaultDay || day.isEnabled !== defaultDay.isEnabled) {
			return true;
		}

		return day.ranges?.some((range, rangeIndex) => {
			return range.id !== defaultDay.ranges?.[rangeIndex]?.id && day.isEnabled;
		});
	});

	return isRuleModified && checkIsAllSelectedHasRanges(selectedSchedule);
};

export const isTimeRangeOverlapping = (newRange: TRange<string>, existingRanges: TRange<string>[]): boolean => {
	if (!existingRanges || existingRanges.length === 0) {
		return false;
	}

	return existingRanges.some((existingRange) => {
		const { from: newFrom, to: newTo } = newRange;
		const { from: existingFrom, to: existingTo } = existingRange;

		return (
			(newFrom >= existingFrom && newFrom < existingTo) ||
			(newTo > existingFrom && newTo <= existingTo) ||
			(newFrom <= existingFrom && newTo >= existingTo)
		);
	});
};

export const sortRuleRanges = (a: IGroupSelectItem, b: IGroupSelectItem) => {
	return (a?.title ?? '').localeCompare(b?.title ?? '', undefined, { numeric: true });
};
